import { render, staticRenderFns } from "./AddTestDialog.vue?vue&type=template&id=50885574"
import script from "./AddTestDialog.vue?vue&type=script&lang=ts"
export * from "./AddTestDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports